"use client";
import { useLocation, useSearchParams } from "react-router-dom";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import EditEventForms from "../../../components/admin/events/EditEventForms";
import { getEventById } from "../../../services/eventsServices";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import EventView from "../../../components/admin/events/EventView";

const EventDetailsAdmin = () => {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("eventId");

  const [event, setEvent] = useState(null);

  const {
    data: eventData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["event", eventId],
    queryFn: () => getEventById(eventId),
    enabled: !!eventId,
  });

  useEffect(() => {
    document.title = "Event Details | Society of Aquaculture Professionals";
  }, []);

  useEffect(() => {
    if (eventData) {
      setEvent(eventData.data);
    }
  }, [eventData]);

  const location = useLocation();

  // Extract query params from URL
  const queryParams = new URLSearchParams(location.search);
  const urlTitle = queryParams.get("title") || "News Details";
  const formattedTitle = decodeURIComponent(urlTitle.replace(/\+/g, " "));

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      {/* Sidebar - fixed, never scrolls */}
      <div className="h-full w-[250px] flex-shrink-0">
        <div className="sticky top-0 h-full">
          <Sidebar />
        </div>
      </div>

      {/* Right-side main content - scrollable */}
      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] flex flex-col overflow-auto">
        <PageWrapper className="flex flex-col flex-1 min-h-0">
          {/* Scrollable area inside */}
          <div className="flex-1 overflow-y-auto p-4 min-h-0">
            <div className="flex items-start w-full gap-2">
              <button
                onClick={() => window.history.back()}
                className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-sm hover:shadow-md transition-shadow"
                title="Go back"
              >
                <span className="text-gray-600 text-lg">←</span>
              </button>{" "}
              <Header
                title={`Event details : ${formattedTitle}`}
                desc="View the details of the event"
              />
            </div>
            <EventView
              event={event}
              isLoading={isLoading}
              isError={isError}
              error={error}
              formattedTitle={formattedTitle}
            />
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default EventDetailsAdmin;
